import { Components, tabsClasses, Theme } from '@mui/material';

export const getMuiTabs = (theme: Theme): Components['MuiTabs'] => ({
  styleOverrides: {
    root: {
      textTransform: 'none',
      fontFeatureSettings: "'case' on, 'cv11' on, 'calt' off",
      boxShadow: 'none',
      alignItems: 'center',

      [`& .${tabsClasses.flexContainer}`]: {
        gap: theme.spacing(7),
      },

      [`& .${tabsClasses.indicator}`]: {
        height: 0,
      },
    },
  },
});
